export function isValidUrl(url = '') {
	const pattern = new RegExp(
		'^(https?:\\/\\/)?' + // protocol
			'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
			'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
			'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
			'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
			'(\\#[-a-z\\d_]*)?$',
		'i'
	); // fragment locator
	return !!pattern.test(url);
};

export function isValidDeeplink (url = '') {
    return url.includes('freefire');
}

export function findKey(object, value) {
    return Object.keys(object).find((key) => object[key].includes(value));
}

export function isElementOverflowing(element) {
    const overflowX = element.offsetWidth < element.scrollWidth,
        overflowY = element.offsetHeight < element.scrollHeight;

    return (overflowX || overflowY);
}

export function scrollTo (selector) {
    document
			.querySelector(`${selector}`)
			.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export function zeroPad (number) {
    if (number < 10) return `0${number}`;
    return number;
}